export default [
  {
    key: 'name',
    label: 'field.unitName',
    type: 'text',
    operator: '%',
  },
];
